import api from '@/common/libs/api'

export default {
  state: {
  },
  mutations: {
  },
  actions: {
  }
}


// WEBPACK FOOTER //
// ./src/stores/modules/orderList/orderList.js